<div class="page-container">
    <div class="container" [ngCommonBusy]="busy">
        <div class="row" *ngIf="currentUser">
            <div class="col-md-12 pt-5">
                <h2>{{ 'central-login.welcome' | translate }} {{ currentUser.lastName }} {{ currentUser.firstName }}</h2>
                <h3 *ngIf="platformUsers && platformUsers.length == 0">{{ 'central-login.login.as' | translate }}</h3>
                <h3 *ngIf="platformUsers && platformUsers.length > 0">{{ 'central-login.login.on.psd.as' | translate }}</h3>
                <span *ngIf="platformUsers && platformUsers.length == 0">{{ 'central-login.currently.not.invited' | translate }}</span>

                <div class="row mt-5">
                    <div class="col-md-3 mb-5"
                         [class.u-opacity--30]="platformUser.platformValidityEnum == PlatformValidityEnum.PLATFORM_INVALID"
                         [class.u-cursor--pointer]="platformUser.platformValidityEnum != PlatformValidityEnum.PLATFORM_INVALID"
                         *ngFor="let platformUser of platformUsers"
                         (click)="selectUser(platformUser, platformUser.platformValidityEnum != PlatformValidityEnum.PLATFORM_INVALID)">
                            <div class="card p-5">
                                <img class="card-img-top rounded" src="{{ getProfilePictureLink(platformUser.platformMemberId, platformUser.apiURL) }}" />
                                <div class="card-body">
                                    <h5 class="card-title text-center font-weight-bold text-truncate">{{ platformUser.platformUserFirstName + ' ' + platformUser.platformUserLastName }}</h5>
                                    <p class="card-text text-center text-truncate">{{ platformUser.platform }}</p>
                                </div>
                            </div>
                    </div>
                </div>

                <h3 class="mt-3">{{ 'central-login.or.go.to' | translate }}</h3>

                <div class="row mt-5">
                    <div class="col-md-3 mb-5 u-cursor--pointer card--account-settings" (click)="goToAccountSettings()">
                        <div class="card p-5">
                            <i class="fa fa-cogs card-icon"></i>
                            <div class="card-body text-center mt-3">
                                {{'central-login.account.settings'|translate}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 mb-5 u-cursor--pointer card--account-settings" (click)="goToHelpdocs()">
                        <div class="card p-5">
                            <i class="fa fa-question-circle card-icon"></i>
                            <div class="card-body text-center mt-3">
                                {{'central-login.support'|translate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<form id="goToPlatformForm" action="" method="post">
    <input type="hidden" name="central_access_token" value="" />
    <input type="hidden" name="central_refresh_token" value="" />
    <input type="hidden" name="refresh_token" value="" />
    <input type="hidden" name="access_token" value="" />
    <input type="hidden" name="expires_in" value="" />
    <input type="hidden" name="force_token_refresh" value="false">
</form>
